import { useCallback, useContext } from "react";
import { ModalContext } from "../Contexts/Modal/modal.context";

// Abre un modal del ModalProvider.
// `contenido` es una función que recibe `cerrar` para que el formulario cierre su propio modal.
export const useModal = () => {
  const { setModals } = useContext(ModalContext);

  const abrirModal = useCallback(
    ({ title, size = "large", contenido }) => {
      const id = `modal-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
      const cerrar = () => setModals((prev) => prev.filter((m) => m.id !== id));
      setModals((prev) => [
        ...prev,
        { id, display: true, title, size, fullMobile: true, children: contenido(cerrar) },
      ]);
      return cerrar;
    },
    [setModals]
  );

  return { abrirModal };
};
